import React, { PropsWithChildren, ReactElement, ReactNode } from 'react'
import classes from './Section.module.scss'
import Typography from '@/components/ui/Typography'
import clsx from 'clsx'
import { Puff } from '@/components/ui/Loaders'
import { GridDraggableCancelClass, GridHandleClass } from '@/components/GridLayout'

export type SectionProps = PropsWithChildren<{
  className?: string
}>

export type HeaderProps = PropsWithChildren<{
  title: string
  isActive?: boolean
  icon?: ReactElement
}>

export type ContentProps = PropsWithChildren<{
  isLoading?: boolean
  isCentered?: boolean
}>

const Section = ({ className, children }: SectionProps) => {
  return <div className={clsx(classes.root, className)}>{children}</div>
}

const Header = ({ title, icon, children, isActive = false }: HeaderProps) => {
  const className = clsx(classes.header, GridHandleClass, {
    [classes.active]: isActive,
  })

  return (
    <div className={className}>
      <div className={classes.title}>
        {icon}
        <Typography isBold>{title}</Typography>
      </div>
      {children && <div className={clsx(GridDraggableCancelClass, classes.actions)}>{children}</div>}
    </div>
  )
}

const Content = ({ isLoading = false, isCentered = false, children }: ContentProps) => {
  const className = clsx(classes.content, {
    [classes.centered]: isCentered || isLoading,
    [classes.loading]: isLoading,
  })

  return <div className={className}>{isLoading ? <Puff size={48} /> : children}</div>
}

const Footer = ({ children }: { children: ReactNode }) => <div className={classes.footer}>{children}</div>

Section.Header = Header
Section.Content = Content
Section.Footer = Footer

export default Section
